export enum ScaleStatus {
  Pending = "pending",
  Loading = "loading",
  VehicleReady = "vehicleReady",
  OrderReady = "orderReady",
  VehicleOverloaded = "vehicleOverloaded",
  OrderOverloaded = "orderOverloaded",
}
